import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common'

@Pipe({
  name: 'amount'
})
export class AmountPipe extends DecimalPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value==null) return value;

    if (value == 0) { return super.transform(value, args); }
    else if (value > 0) { return "DR " + super.transform(value, args); }
    { return "CR " + super.transform(-value, args); }
  }

}
